import React, { useState } from "react";

import { Card, CardBody, Table, FormGroup, Input, Badge, Row, Col, Button, Label, } from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";

import useFbForms from "../../../Hooks/useFbForms";
import useFbPages from "../../../Hooks/useFbPages";

const FbFormsManager = () => {

  const [search, setSearch] = useState("");
  const [pageId, setPageId] = useState("");
  const [page, setPage] = useState(1);
  const [isActive, setIsActive] = useState(true);
  const [leadSyncStatus, setLeadSyncStatus] = useState("");
  const { pages } = useFbPages();
  const { forms, pagination, updateStatus } = useFbForms({
    search,
    pageId,
    page,
    isActive,
    leadSyncStatus,
  });


  return (
    <div className="page-content">

      <Breadcrumbs
        title="Settings"
        breadcrumbItem="FB Forms Manager"
      />

      <Card>

        <CardBody>

          <Row className="mb-3">

            <Col md={4}>
              <Label for="Search">Search forms</Label>
              <Input
                placeholder="Search Forms / Page"
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setPage(1);
                }}
              />
            </Col>
            <Col md={2}>
              <Label for="isActiveSelect">Status</Label>
              <Input
                type="select"
                value={isActive}
                onChange={(e) => {
                  setIsActive(e.target.value);
                  setPage(1);
                }}
              >
                <option value="">
                  Filter By Status
                </option>

                <option value="true">
                  Active
                </option>

                <option value="false">
                  Inactive
                </option>
              </Input>
            </Col>
            <Col md={3}>
              <Label for="leadSync">LeadSync</Label>
              <Input
                type="select"
                value={leadSyncStatus}
                onChange={(e) => {
                  setLeadSyncStatus(e.target.value);
                  setPage(1);
                }}
              >
                <option value="">
                  Filter By Status
                </option>

                <option value="true">
                  Active
                </option>

                <option value="false">
                  Inactive
                </option>
              </Input>
            </Col>
            <Col md={3}>
              <Label for="page">Pages</Label>
              <Input
                type="select"
                value={pageId}
                onChange={(e) => {
                  setPageId(e.target.value);
                  setPage(1);
                }}
              >
                <option value="">
                  Filter By Page
                </option>

                {pages.map((p) => (
                  <option
                    key={p.refId}
                    value={p.refId}
                  >
                    {p.name}
                  </option>
                ))}

              </Input>
            </Col>

          </Row>

          <Table bordered hover responsive>

            <thead>
              <tr>
                <th>Form Name</th>
                <th>Page Name</th>
                <th>FB Status</th>
                <th>Lead Sync</th>
                {/* <th>Last Sync</th> */}
              </tr>
            </thead>

            <tbody>

              {forms.map((f) => (
                <tr key={f._id}>

                  <td>{f.formName}</td>

                  <td>{f.pageName}</td>

                  <td>
                    <Badge
                      color={
                        f.status === "ACTIVE"
                          ? "success"
                          : "danger"
                      }
                    >
                      {f.status}
                    </Badge>
                  </td>

                  <td>
                    <div className="d-flex align-items-center">
                      <input
                        id={`lead-sync-${f._id}`}
                        type="checkbox"
                        switch="primary"
                        checked={f.leadSyncStatus}
                        onChange={(e) =>
                          updateStatus(
                            f._id,
                            e.target.checked
                          )
                        }
                      />
                      <label
                        htmlFor={`lead-sync-${f._id}`}
                        data-on-label=""
                        data-off-label=""
                        className="mb-0"
                      />
                    </div>
                  </td>

                  {/* <td>
                    {f.lastLeadSyncAt
                      ? new Date(
                          f.lastLeadSyncAt
                        ).toLocaleString()
                      : "-"}
                  </td> */}

                </tr>
              ))}

            </tbody>

          </Table>

          <div className="d-flex justify-content-end gap-2">

            <Button
              disabled={page <= 1}
              onClick={() =>
                setPage((prev) => prev - 1)
              }
            >
              Prev
            </Button>

            <Button disabled>
              {pagination.page} / {pagination.totalPages}
            </Button>

            <Button
              disabled={
                page >= pagination.totalPages
              }
              onClick={() =>
                setPage((prev) => prev + 1)
              }
            >
              Next
            </Button>

          </div>

        </CardBody>

      </Card>

    </div>
  );
};

export default FbFormsManager;